import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalsoftDrawerComponent } from './drawer.component';

@NgModule({
    declarations: [
        CalsoftDrawerComponent
    ],
    imports     : [
        CommonModule
    ],
    exports     : [
        CalsoftDrawerComponent
    ]
})
export class CalsoftDrawerModule
{
}
